export default "__VITE_ASSET__Bpz70y8M__"